import { Icon } from "@/components";
import { formatCurrency } from "@/lib/currency/currency";
import { useI18n } from "@/lib/i18n/i18n_provider";
import { getSystemLocale } from "@/lib/locale/locale";
import React from "react";

interface SavingAmountLabelProps {
  price: number;
  currency: string | null;
}

export function SavingAmountLabel(props: SavingAmountLabelProps) {
  const { price, currency } = props;
  const { fbt } = useI18n();

  return (
    <div
      data-testid="saving-amount"
      className="px-2 py-1 bg-success-subtle rounded text-success"
      style={{ fontSize: 12 }}
    >
      <Icon color="038231" name="price-tag" size={15} />{" "}
      <span>
        {fbt(
          "You're saving " +
            fbt.param(
              "price",
              formatCurrency(price, currency, getSystemLocale())
            )
        )}
      </span>
    </div>
  );
}
